import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";

import { EMPTY_STRING, inventoryConstants } from "../../../../constants";
import { addCustomItemValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import CustomInventoryComponent from "../../../../shared/components/inventory/CustomInventoryComponent";
import {
  getTypeOrCategoryObject,
  getCustomProductIfExist,
  getTypeOrCategoryIdByName,
  getCustomProductConditionList,
  handleCalculateEachProductPercentage,
  getBatchCustomItemInitialValues,
  getBatchCustomItemSubmitMapping,
  getAddInventoryPricePayloadObject,
} from "../../../../shared/utility";

const AddCustomItem = ({
  inventory,
  addToCart,
  shopifySettings,
  itemOrganization,
  editCustomProduct,
  isCustomItemModal,
  toggleCustomItemModal,
  invoiceBatchInventory,
  setInvoiceBatchInventory,
}) => {
  const formikRef = useRef();

  //-------Reducer
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;
  const { productTags } = inventory;

  //--------useState
  const [customProductSelectedTags, setCustomProductSelectedTags] = useState(
    editCustomProduct
      ? editCustomProduct?.tags?.filter(
          (tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG
        )
      : []
  );

  const [isProductExist, setIsProductExist] = useState(false);

  //-------inital values for customItem
  const customItemInitialValues = {
    ...getBatchCustomItemInitialValues(
      editCustomProduct,
      customTypes,
      customCategories,
      customSubCategories,
      shopifySettings.global
    ),
  };

  //-------Handle Hide Modal
  const handleHideModal = () => {
    toggleCustomItemModal();
  };

  //-------handle Custom Item Submit
  const handleCustomItemSubmit = (values) => {
    const itemToAdd = {
      ...getBatchCustomItemSubmitMapping(
        values,
        customTypes,
        customCategories,
        customSubCategories,
        customProductSelectedTags,
        editCustomProduct
      ),
      costOfGoods: values.costOfGoods,
    };

    const { quantity, onlineQuantity } =
      getAddInventoryPricePayloadObject(values);

    if (editCustomProduct?.id || editCustomProduct?.id === 0) {
      addToCart({
        ...editCustomProduct,
        ...itemToAdd,
        inStockQuantity: quantity,
        onlineQuantity,
      });
    } else {
      setInvoiceBatchInventory(
        handleCalculateEachProductPercentage([
          ...invoiceBatchInventory,
          {
            ...itemToAdd,
            id: invoiceBatchInventory?.length,
            inStockQuantity: quantity,
            onlineQuantity,
            isDataFetching: true,
          },
        ])
      );
    }
    handleHideModal();
  };

  //-------onselectedtagchange
  const onCustomProductSelectTagsChange = (selectedTags) => {
    const selectedTagList = selectedTags.map((tag) => tag.label);
    setCustomProductSelectedTags(selectedTagList);
  };

  return (
    <Modal
      show={isCustomItemModal}
      size="lg"
      onHide={handleHideModal}
      animation={true}
      centered
      backdrop="static"
      className="add-inventory-modal"
    >
      <Modal.Header closeButton className="add-inventory-modal-header">
        <Modal.Title>
          <span className="add-inventory-modal-header-name">
            {editCustomProduct ? "Edit Custom Item" : "Add Custom Item"}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="add-inventory-modal-body p-1">
        <Row className="m-0">
          <Formik
            formikRef={formikRef}
            initialValues={customItemInitialValues}
            validate={addCustomItemValidationSchema}
            onSubmit={handleCustomItemSubmit}
          >
            {({ values, setFieldValue }) => {
              setIsProductExist(
                getCustomProductIfExist(
                  values,
                  customTypes,
                  customCategories,
                  editCustomProduct,
                  customSubCategories,
                  customProductSelectedTags,
                  true
                )
              );
              return (
                <Form className="px-0">
                  <Col md={12} className="px-0">
                    <CustomInventoryComponent
                      values={values}
                      formikRef={formikRef}
                      productTags={productTags}
                      setFieldValue={setFieldValue}
                      isProductExist={isProductExist}
                      handleHideModal={handleHideModal}
                      isCustomItemTab={true}
                      setIsCustomItemTab={() => {}}
                      customProductSelectedTags={customProductSelectedTags}
                      onCustomProductSelectTagsChange={
                        onCustomProductSelectTagsChange
                      }
                      isEditCustomItemModal={!editCustomProduct}
                    />
                  </Col>
                </Form>
              );
            }}
          </Formik>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  itemOrganization: state.itemOrganization,
  shopifySettings: state.shopify.shopifySettings,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddInvoice Component
export default connect(mapStateToProps, mapDispatchToProps)(AddCustomItem);
